module.exports = __webpack_public_path__ + "img/gift-blanket.f8ed2850.svg";